import React from "react";
import { Box } from "@mui/material";
import EditBtnIcon from "../icons/EditBtnIcon";

const EditButton = ({ handleClick }) => {
  return (
    <Box
      className="edit-button-image"
      onClick={handleClick}
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "30px",
      }}
    >
      <EditBtnIcon />
    </Box>
  );
};

export default EditButton;
